import React from "react";

import { reais } from "../../ofertas-do-dia/admin/formato";

export default function RankingSugestoes({ ranking }) {
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="ranking-sugestoes">
      <h3 className="font-semibold">Produtos sugeridos que mais renderam</h3>
      <p className="text-xs text-muted-foreground mb-3">Taxa de adição = quantas vezes entrou no carrinho a cada vez que apareceu.</p>
      {(ranking || []).length === 0 ? (
        <p className="text-sm text-muted-foreground py-4 text-center">Sem sugestões no período.</p>
      ) : (
        <ol className="space-y-2">
          {ranking.map((p, i) => (
            <li key={p.produto_id} className="flex items-center gap-3 text-sm">
              <span className="w-5 text-right text-xs text-muted-foreground tabular-nums">{i + 1}</span>
              <span className="flex-1 min-w-0 truncate font-medium">{p.nome}</span>
              <span className="text-xs text-muted-foreground tabular-nums hidden sm:inline">
                {p.exibidas} exib. · {p.exibidas ? Math.round((p.adicionadas * 100) / p.exibidas) : 0}% adição
              </span>
              <span className="w-24 text-right font-semibold tabular-nums">{reais(p.receita)}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
